import { faXmark } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MovimientoBancarioReadingDtoProps } from "api/DTOs/MovimientoBancarioReadingDto"
import { ESTADO_CONCILIACION } from "api/Types/EstadoConciliacion"
import { TIPO_CONCILIACION } from "api/Types/TipoConciliacion"
import { ColoredNumber } from "features/Contabilidad/components/ColoredNumber"
import { TFunction } from "i18next"
import { isNumber } from "lodash"
import { frontendDateFormat } from "utils/formatDate"
import { Progress } from "../components/Progress"

export const CONCILIACION_MANUAL_COLUMNS = (
  t: TFunction,
  OptionsButton: (row: MovimientoBancarioReadingDtoProps) => JSX.Element
) => {
  const columns = [
    {
      key: "fecha",
      field: "fecha",
      header: `${t("bancos.conciliacion.manualTable.headerDate")}`,
      body: ({ fecha }: MovimientoBancarioReadingDtoProps) =>
        fecha ? frontendDateFormat(new Date(fecha)) : "-",
      style: { width: "10%" },
      sortable: true,
      sortField: "ValueDate",
    },
    {
      key: "concepto",
      field: "concepto",
      header: `${t("bancos.conciliacion.manualTable.headerConcept")}`,
      body: ({ concepto }: MovimientoBancarioReadingDtoProps) => (
        <span>{concepto || "-"}</span>
      ),
    },
    {
      key: "conciliacionBancariaId",
      field: "conciliacionBancariaId",
      header: "",
      style: { width: "5%" },
      body: (rowData: MovimientoBancarioReadingDtoProps) => {
        return Progress({
          t,
          forzada: rowData?.tipoConciliacion === TIPO_CONCILIACION.FORZADA,
          conciliada:
            rowData?.estadoConciliacion === ESTADO_CONCILIACION.CONCILIADO,
          percent: 0,
        })
      },
    },
    {
      key: "importe",
      field: "importe",
      header: `${t("bancos.conciliacion.manualTable.headerAmount")}`,
      body: ({ importe }: MovimientoBancarioReadingDtoProps) =>
        isNumber(importe) ? ColoredNumber(importe) : "-",
      style: { width: "15%" },
      className: "!tw-text-end",
      alignCol: "right",
      sortable: true,
      sortField: "Amount",
    },
    {
      key: "ellipsisButton",
      field: "ellipsisButton",
      style: { width: "4%" },
      header: "",
      body: (rowData: MovimientoBancarioReadingDtoProps) =>
        OptionsButton(rowData),
    },
  ]
  return columns
}

export const CONCILIACION_MANUAL_SELECTED_COLUMNS = (
  t: TFunction,
  unSelectedRow: (rowData: MovimientoBancarioReadingDtoProps) => void
) => {
  const columns = [
    {
      key: "unselected",
      field: "unselected",

      body: (rowData: MovimientoBancarioReadingDtoProps) => (
        <FontAwesomeIcon
          icon={faXmark}
          className='tw-text-danger tw-cursor-pointer'
          onClick={() => unSelectedRow(rowData)}
        />
      ),
      style: { width: "4%" },
      sortable: true,
      sortField: "ValueDate",
    },
    {
      key: "fecha",
      field: "fecha",
      header: `${t(
        "bancos.conciliacion.rightColumn.conciliatedMovementsTable.headerDate"
      )}`,
      body: ({ fecha }: MovimientoBancarioReadingDtoProps) =>
        fecha ? frontendDateFormat(new Date(fecha)) : "-",
      style: { width: "10%" },
      sortable: true,
      sortField: "ValueDate",
    },
    {
      key: "concepto",
      field: "concepto",
      header: `${t(
        "bancos.conciliacion.rightColumn.conciliatedMovementsTable.headerConcept"
      )}`,
      body: ({ concepto }: MovimientoBancarioReadingDtoProps) => (
        <span>{concepto || "-"}</span>
      ),
    },
    {
      key: "importe",
      field: "importe",
      header: `${t(
        "bancos.conciliacion.rightColumn.conciliatedMovementsTable.headerAmount"
      )}`,
      body: ({ importe }: MovimientoBancarioReadingDtoProps) =>
        isNumber(importe) ? ColoredNumber(importe) : "-",
      style: { width: "15%" },
      className: "!tw-text-end",
      alignCol: "right",
      sortable: true,
      sortField: "Amount",
    },
  ]
  return columns
}
